import { render } from "./ThanksPanel.vue?vue&type=template&id=58893aea&ts=true"
import script from "./ThanksPanel.vue?vue&type=script&lang=ts"
export * from "./ThanksPanel.vue?vue&type=script&lang=ts"

import "./ThanksPanel.vue?vue&type=style&index=0&id=58893aea&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__